
import React, { useEffect, useState,useRef } from "react";
import { ThirdWorkTreeAPI } from "../services/api";


interface TakeOffItem {
  takeoffNo: number;
  takeOff: string;
  geometry?: number;
  geometryName?: string;
  quantity?: number;
  subMark?: number;
  subMarkName?: string;
  work?: number;
}

interface Props {
  workNo: number | null;
}

const TakeOffPanel: React.FC<Props> = ({ workNo }) => {
  const [rows, setRows] = useState<TakeOffItem[]>([]);
  const [loading, setLoading] = useState(false);

 
 /*  const [columnWidths, setColumnWidths] = useState({
  sno: 60,
  takeoff: 180,
  geometry: 180,
  quantity: 100,
  submark: 180,
}); */
 

  const [columnWidths, setColumnWidths] = useState({
  sno: 45,
  takeoff: 120,
  geometry: 120,
  quantity: 80,
  submark: 120,
}); 
 
const [selectionStart, setSelectionStart] = useState<{
  row: number;
  column: string;
} | null>(null);

const [selectionEnd, setSelectionEnd] = useState<{
  row: number;
  column: string;
} | null>(null);

const [isSelecting, setIsSelecting] = useState(false);
const [selectAll, setSelectAll] = useState(false);

const [isCopied, setIsCopied] = useState(false);
const [selectionOverlay, setSelectionOverlay] = useState<{
  left: number;
  top: number;
  width: number;
  height: number;
} | null>(null);
const tableRef = useRef<HTMLTableElement>(null);

const resizingRef = React.useRef<{
  column: keyof typeof columnWidths;
  startX: number;
  startWidth: number;
} | null>(null);

const allColumns = [
  "sno",
  "takeoff",
  "geometry",
  "quantity",
  "submark",
];

  useEffect(() => {
    if (!workNo) {        
      setRows([]);
      return;
    }

    setLoading(true);

    ThirdWorkTreeAPI.getTakeOffs(workNo)
      .then(setRows)
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [workNo]);

  useEffect(() => {
  const stopSelecting = () => {
    setIsSelecting(false);
  };

  window.addEventListener(
    "mouseup",
    stopSelecting
  );

  return () => {
    window.removeEventListener(
      "mouseup",
      stopSelecting
    );
  };
}, []);

  if (!workNo) {
    return (
      <div className="h-full flex items-center justify-center text-gray-500">
        Select a Work
      </div>
    );
  }

  if (loading) {
    return (
      <div className="h-full flex items-center justify-center">
        Loading...
      </div>
    );
  }
  const isCellSelected = (
  rowIndex: number,
  columnKey: string
) => {
  if (!selectionStart || !selectionEnd) return false;

  const startRow = Math.min(
    selectionStart.row,
    selectionEnd.row
  );

  const endRow = Math.max(
    selectionStart.row,
    selectionEnd.row
  );

  const startCol = Math.min(
    allColumns.indexOf(selectionStart.column),
    allColumns.indexOf(selectionEnd.column)
  );

  const endCol = Math.max(
    allColumns.indexOf(selectionStart.column),
    allColumns.indexOf(selectionEnd.column)
  );

  const currentCol =
    allColumns.indexOf(columnKey);

  return (
    rowIndex >= startRow &&
    rowIndex <= endRow &&
    currentCol >= startCol &&
    currentCol <= endCol
  );
};




const isHeaderSelected = (columnKey: string) => {
  if (!selectionStart || !selectionEnd) return false;

  const startCol = Math.min(
    allColumns.indexOf(selectionStart.column),
    allColumns.indexOf(selectionEnd.column)
  );

  const endCol = Math.max(
    allColumns.indexOf(selectionStart.column),
    allColumns.indexOf(selectionEnd.column)
  );

  const currentCol = allColumns.indexOf(columnKey);

  return currentCol >= startCol && currentCol <= endCol;
};

const getSelectionBorderClass = (
  rowIndex: number,
  columnKey: string
) => {
  if (!selectionStart || !selectionEnd) return "";

  // Don't add any green border to cells outside the selection
  if (!isCellSelected(rowIndex, columnKey)) {
    return "";
  }

  const startRow = Math.min(selectionStart.row, selectionEnd.row);
  const endRow = Math.max(selectionStart.row, selectionEnd.row);

  const startCol = Math.min(
    allColumns.indexOf(selectionStart.column),
    allColumns.indexOf(selectionEnd.column)
  );

  const endCol = Math.max(
    allColumns.indexOf(selectionStart.column),
    allColumns.indexOf(selectionEnd.column)
  );

  const col = allColumns.indexOf(columnKey);

  let cls = "";

  if (rowIndex === startRow) cls += " border-t-[2px] border-t-green-600";
  if (rowIndex === endRow) cls += " border-b-[2px] border-b-green-600";
  if (col === startCol) cls += " border-l-[2px] border-l-green-600";
  if (col === endCol) cls += " border-r-[2px] border-r-green-600";

  return cls;
};

const startResize =
  (column: keyof typeof columnWidths) =>
  (e: React.PointerEvent<HTMLDivElement>) => {
    e.preventDefault();

    resizingRef.current = {
      column,
      startX: e.clientX,
      startWidth: columnWidths[column],
    };

    const onMove = (ev: PointerEvent) => {
      if (!resizingRef.current) return;

      const width =
        resizingRef.current.startWidth +
        (ev.clientX - resizingRef.current.startX);

      setColumnWidths((prev) => ({
        ...prev,
        [column]: Math.max(60, width),
      }));
    };

    const onUp = () => {
      window.removeEventListener("pointermove", onMove);
      window.removeEventListener("pointerup", onUp);
      resizingRef.current = null;
    };

    window.addEventListener("pointermove", onMove);
    window.addEventListener("pointerup", onUp);
  };

  const handleSelectAll = async () => {
   setSelectAll(true);
  setSelectionStart({
    row: 0,
    column: allColumns[0],
  });

  setSelectionEnd({
    row: rows.length - 1,
    column: allColumns[allColumns.length - 1],
  });

  /* const text = rows
    .map((row, index) =>
      [
        index + 1,
        row.takeOff ?? "",
        row.geometryName ?? "",
        row.quantity != null
          ? row.quantity.toFixed(3)
          : "",
        row.subMarkName ?? "",
      ].join("\t")
    )
    .join("\n");

  await navigator.clipboard.writeText(text); */

  const header = [
  "S.No",
  "TakeOff",
  "Geometry",
  "Quantity",
  "SubMark",
].join("\t");

const body = rows
  .map((row, index) =>
    [
      index + 1,
      row.takeOff ?? "",
      row.geometryName ?? "",
      row.quantity != null
        ? row.quantity.toFixed(3)
        : "",
      row.subMarkName ?? "",
    ].join("\t")
  )
  .join("\n");

const text = header + "\n" + body;

await navigator.clipboard.writeText(text);
};


const handleKeyDown = (
  e: React.KeyboardEvent<HTMLDivElement>
) => {
  if (!selectionEnd) return;

  const currentRow = selectionEnd.row;

  const currentColIndex =
    allColumns.indexOf(selectionEnd.column);

 /*  if (
    e.ctrlKey &&
    e.key.toLowerCase() === "c"
  ) {
    e.preventDefault();
    handleSelectAll();
    return;
  } */
 if (e.ctrlKey && e.key.toLowerCase() === "c") {
  e.preventDefault();
  copySelectedCells();
  return;
}

  if (e.shiftKey) {
    e.preventDefault();

    switch (e.key) {
      case "ArrowDown":
        setSelectionEnd({
          row: selectionEnd.row + 1,
          column: selectionEnd.column,
        });
        return;

      case "ArrowUp":
        setSelectionEnd({
          row: Math.max(
            0,
            selectionEnd.row - 1
          ),
          column: selectionEnd.column,
        });
        return;

      case "ArrowRight":
        if (
          currentColIndex <
          allColumns.length - 1
        ) {
          setSelectionEnd({
            row: selectionEnd.row,
            column:
              allColumns[currentColIndex + 1],
          });
        }
        return;

      case "ArrowLeft":
        if (currentColIndex > 0) {
          setSelectionEnd({
            row: selectionEnd.row,
            column:
              allColumns[currentColIndex - 1],
          });
        }
        return;
    }
  }

  switch (e.key) {
    case "ArrowDown":
      e.preventDefault();

      setSelectionStart({
        row: Math.min(
          rows.length - 1,
          currentRow + 1
        ),
        column: selectionEnd.column,
      });

      setSelectionEnd({
        row: Math.min(
          rows.length - 1,
          currentRow + 1
        ),
        column: selectionEnd.column,
      });

      break;

    case "ArrowUp":
      e.preventDefault();

      setSelectionStart({
        row: Math.max(
          0,
          currentRow - 1
        ),
        column: selectionEnd.column,
      });

      setSelectionEnd({
        row: Math.max(
          0,
          currentRow - 1
        ),
        column: selectionEnd.column,
      });

      break;

    case "ArrowRight":
      e.preventDefault();

      if (
        currentColIndex <
        allColumns.length - 1
      ) {
        setSelectionStart({
          row: currentRow,
          column:
            allColumns[currentColIndex + 1],
        });

        setSelectionEnd({
          row: currentRow,
          column:
            allColumns[currentColIndex + 1],
        });
      }

      break;

    case "ArrowLeft":
      e.preventDefault();

      if (currentColIndex > 0) {
        setSelectionStart({
          row: currentRow,
          column:
            allColumns[currentColIndex - 1],
        });

        setSelectionEnd({
          row: currentRow,
          column:
            allColumns[currentColIndex - 1],
        });
      }

      break;

    case "Enter":
      e.preventDefault();

      setSelectionStart({
        row: Math.min(
          rows.length - 1,
          currentRow + 1
        ),
        column: selectionEnd.column,
      });

      setSelectionEnd({
        row: Math.min(
          rows.length - 1,
          currentRow + 1
        ),
        column: selectionEnd.column,
      });

      break;

    case "Tab":
      e.preventDefault();

      if (e.shiftKey) {
        if (currentColIndex > 0) {
          setSelectionStart({
            row: currentRow,
            column:
              allColumns[currentColIndex - 1],
          });

          setSelectionEnd({
            row: currentRow,
            column:
              allColumns[currentColIndex - 1],
          });
        }
      } else {
        if (
          currentColIndex <
          allColumns.length - 1
        ) {
          setSelectionStart({
            row: currentRow,
            column:
              allColumns[currentColIndex + 1],
          });

          setSelectionEnd({
            row: currentRow,
            column:
              allColumns[currentColIndex + 1],
          });
        }
      }

      break;
  }
};
/* const autoFitColumn = (
  column: keyof typeof columnWidths
) => 
{
  let maxWidth = 60;

  rows.forEach((row, index) => {
    let value = "";

    switch (column) {
      case "sno":
        value = String(index + 1);
        break;

      case "takeoff":
        value = row.takeOff ?? "";
        break;

      case "geometry":
        value = row.geometryName ?? "";
        break;

      case "quantity":
        value = row.quantity?.toFixed(3) ?? "";
        break;

      case "submark":
        value = row.subMarkName ?? "";
        break;
    }

    maxWidth = Math.max(
      maxWidth,
      value.length * 8 + 20
    );
  });

  setColumnWidths((prev) => ({
    ...prev,
    [column]: maxWidth,
  }));
};
 */
const autoFitColumn = (
  column: keyof typeof columnWidths
) => {
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d")!;

  ctx.font = "13px Segoe UI";

  let maxWidth = 45;

  rows.forEach((row, index) => {
    let value = "";

    switch (column) {
      case "sno":
        value = String(index + 1);
        break;

      case "takeoff":
        value = row.takeOff ?? "";
        break;

      case "geometry":
        value = row.geometryName ?? "";
        break;

      case "quantity":
        value = row.quantity?.toFixed(3) ?? "";
        break;

      case "submark":
        value = row.subMarkName ?? "";
        break;
    }

    maxWidth = Math.max(
      maxWidth,
      ctx.measureText(value).width + 8
    );
  });

  setColumnWidths(prev => ({
    ...prev,
    [column]: maxWidth,
  }));
};

const copySelectedCells = async () => {
  if (!selectionStart || !selectionEnd) return;

  const startRow = Math.min(selectionStart.row, selectionEnd.row);
  const endRow = Math.max(selectionStart.row, selectionEnd.row);

  const startCol = Math.min(
    allColumns.indexOf(selectionStart.column),
    allColumns.indexOf(selectionEnd.column)
  );

  const endCol = Math.max(
    allColumns.indexOf(selectionStart.column),
    allColumns.indexOf(selectionEnd.column)
  );

  const text = [];

  for (let r = startRow; r <= endRow; r++) {
    const row = rows[r];
    const values = [];

    for (let c = startCol; c <= endCol; c++) {
      switch (allColumns[c]) {
        case "sno":
          values.push(String(r + 1));
          break;

        case "takeoff":
          values.push(row.takeOff ?? "");
          break;

        case "geometry":
          values.push(row.geometryName ?? "");
          break;

        case "quantity":
          values.push(
            row.quantity != null
              ? row.quantity.toFixed(3)
              : ""
          );
          break;

        case "submark":
          values.push(row.subMarkName ?? "");
          break;
      }
    }

    text.push(values.join("\t"));
  }

 await navigator.clipboard.writeText(text.join("\n"));

setIsCopied(true);
};

  return (
   
      /* <div
  tabIndex={0}
  onKeyDown={handleKeyDown}
  className="h-full overflow-auto thin-scrollbar outline-none"
       */

  <div
  tabIndex={0}
  onKeyDown={handleKeyDown}
  onMouseDown={(e) => {
    const target = e.target as HTMLElement;

    if (!target.closest("table")) {
      setSelectionStart(null);
      setSelectionEnd(null);
        setSelectAll(false);
setIsCopied(false);
    }
  }}
  className="h-full overflow-auto thin-scrollbar outline-none"

  
  style={{
        fontFamily: "'Segoe UI', sans-serif",
        fontSize: "13px",
      }}
    >
      {rows.length === 0 ? (
        <div className="p-4 text-gray-500">
          No TakeOffs found
        </div>
      ) : (
        // <table className="w-full border-collapse">
        <table   ref={tableRef}
  className="border-collapse select-none"
  style={{
    //minWidth: "100%",
      minWidth: "max-content",
  }}
>
  <colgroup>
  <col style={{ width: columnWidths.sno }} />
  <col style={{ width: columnWidths.takeoff }} />
  <col style={{ width: columnWidths.geometry }} />
  <col style={{ width: columnWidths.quantity }} />
  <col style={{ width: columnWidths.submark }} />
</colgroup>
          <thead
            style={{
              position: "sticky",
              top: 0,
              zIndex: 10,
              background: "#f3f4f6",
            }}
          >
            <tr>
             {/*  <th className="border border-gray-300 px-2 py-1 text-left w-16">
                S.No
              </th> */}
          {/*   <th
  className="relative border border-gray-300 px-2 py-1 text-center cursor-pointer"
  onMouseDown={handleSelectAll}
> */}
<th
 className={`relative border border-gray-300 px-1 py-0 text-center cursor-pointer
 
  ${selectAll ? "bg-[#e6e6e6] border-t-[2px] border-l-[2px] border-green-600" : ""}
`}
 style={{
  height: "24px",
  lineHeight: "24px",
}}
  onMouseDown={handleSelectAll}
>
  ◢


             <div
              onPointerDown={startResize("sno")}
               onDoubleClick={() => autoFitColumn("sno")}
              //className="absolute right-0 top-0 h-full w-2 cursor-col-resize"
              className="absolute right-0 top-0 h-full w-[4px] cursor-col-resize"
              />
            </th>

              {/* <th className="relative border border-gray-300 px-2 py-1 text-left"> */}
            <th
 // className={`relative border border-gray-300 px-1 text-left
 className={`relative border border-gray-300 px-2 py-1 text-left
  ${
    selectAll
      ? "bg-[#e6e6e6] border-t-[2px] border-green-600"
      : ""
  }
`} 

  style={{
    height: "26px",
    lineHeight: "20px",
  }}
>

                 TakeOff

                <div
                onPointerDown={startResize("takeoff")}
                onDoubleClick={() => autoFitColumn("takeoff")}
             // className="absolute right-0 top-0 h-full w-[4px] cursor-col-resize"
              className="absolute right-0 top-0 h-full w-[8px] cursor-col-resize"
                 />
              </th>

            {/*   <th className="relative border border-gray-300 px-2 py-1 text-left"> */}
           <th
// className={`relative border border-gray-300 px-1 text-left
className={`relative border border-gray-300 px-2 py-1 text-left
  ${
    selectAll
      ? "bg-[#e6e6e6] border-t-[2px] border-green-600"
      : ""
  }
`}
  style={{
    height: "26px",
    lineHeight: "20px",
  }}
>

  Geometry

  <div
    onPointerDown={startResize("geometry")}
     onDoubleClick={() => autoFitColumn("geometry")}
   className="absolute right-0 top-0 h-full w-[4px] cursor-col-resize"
  />
</th>

             {/*  <th className="relative border border-gray-300 px-2 py-1 text-left"> */}
             <th
// className={`relative border border-gray-300 px-1 text-left
className={`relative border border-gray-300 px-2 py-1 text-left
  ${
    selectAll
      ? "bg-[#e6e6e6] border-t-[2px] border-green-600"
      : ""
  }
`}
  style={{
    height: "26px",
    lineHeight: "20px",
  }}
>
  Quantity

  <div
    onPointerDown={startResize("quantity")}
     onDoubleClick={() => autoFitColumn("quantity")}
   className="absolute right-0 top-0 h-full w-[4px] cursor-col-resize"
  />
</th>

             {/* <th className="relative border border-gray-300 px-2 py-1 text-left"> */}
             <th
 //className={`relative border border-gray-300 px-1 text-left
 className={`relative border border-gray-300 px-2 py-1 text-left
  ${
    selectAll
      ? "bg-[#e6e6e6] border-t-[2px] border-r-[2px] border-green-600"
      : ""
  }
`}
  style={{
    height: "26px",
    lineHeight: "20px",
  }}
>
  SubMark

  <div
    onPointerDown={startResize("submark")}
     onDoubleClick={() => autoFitColumn("submark")}
    className="absolute right-0 top-0 h-full w-[4px] cursor-col-resize"
  />
</th>
            </tr>
          </thead>

          <tbody>
            {rows.map((row, index) => (
              <tr
                key={row.takeoffNo}
               // className="hover:bg-blue-50"
              >
              {/*  <td
  onClick={() =>
    setSelectedCell({
      row: index,
      column: "sno",
    })
  }
  className={`border border-gray-300 px-2 py-1 cursor-pointer
    ${
      selectedCell?.row === index &&
      selectedCell?.column === "sno"
        ? "bg-[#d9d9d9]"
        : ""
    }`}
>
  {index + 1}
</td> */}
<td
  onMouseDown={() => {
     setSelectAll(false);
setIsCopied(false);
    setSelectionStart({
      row: index,
      column: "sno",
    });

    setSelectionEnd({
      row: index,
      column: "sno",
    });

    

    setIsSelecting(true);
  }}
  onMouseEnter={() => {
    if (!isSelecting) return;

    setSelectionEnd({
      row: index,
      column: "sno",
    });
  }}
  //className={`border border-gray-300 px-2 py-1 cursor-pointer
 /*  className={`border border-gray-300 px-1 py-0 cursor-pointer whitespace-nowrap overflow-hidden text-clip
    ${isCellSelected(index, "sno") ? "bg-[#e6e6e6]" : ""}
    `} */
   className={`border border-gray-300 px-2 py-1 h-[26px] leading-[20px] cursor-pointer whitespace-nowrap overflow-hidden text-clip
    ${isCellSelected(index, "sno") ? "bg-[#e6e6e6]" : ""}
    ${getSelectionBorderClass(index, "sno")}
    ${isCopied && isCellSelected(index, "sno") ? "copy-selection" : ""}
`}
>
  {index + 1}
</td>

               <td
  onMouseDown={() => {
      setSelectAll(false);
setIsCopied(false);
    setSelectionStart({
      row: index,
      column: "takeoff",
    });

    setSelectionEnd({
      row: index,
      column: "takeoff",
    });

    

    setIsSelecting(true);
  }}
  onMouseEnter={() => {
    if (!isSelecting) return;

    setSelectionEnd({
      row: index,
      column: "takeoff",
    });
  }}
  //className={`border border-gray-300 px-2 py-1 cursor-pointer
  //className={`border border-gray-300 px-2 py-1 cursor-pointer whitespace-nowrap overflow-hidden text-ellipsis
 //className={`border border-gray-300 px-1 py-0 cursor-pointer whitespace-nowrap overflow-hidden text-clip
 className={`border border-gray-300 px-2 py-1 h-[26px] leading-[20px] cursor-pointer whitespace-nowrap overflow-hidden text-clip
    ${isCellSelected(index, "takeoff") ? "bg-[#e6e6e6]" : ""}
    ${getSelectionBorderClass(index, "takeoff")}
    ${isCopied && isCellSelected(index, "takeoff") ? "copy-selection" : ""}
`}
>
  {row.takeOff}
</td>

              <td
  onMouseDown={() => {
      setSelectAll(false);
setIsCopied(false);
    setSelectionStart({
      row: index,
      column: "geometry",
    });

    setSelectionEnd({
      row: index,
      column: "geometry",
    });

   

    setIsSelecting(true);
  }}
  onMouseEnter={() => {
    if (!isSelecting) return;

    setSelectionEnd({
      row: index,
      column: "geometry",
    });
  }}
  //className={`border border-gray-300 px-2 py-1 cursor-pointer
 /* className={`border border-gray-300 px-1 py-0 cursor-pointer whitespace-nowrap overflow-hidden text-clip
    ${isCellSelected(index, "geometry") ? "bg-[#e6e6e6]" : ""}
     `} */

   //className={`border border-gray-300 px-1 py-0 cursor-pointer whitespace-nowrap overflow-hidden text-clip
   className={`border border-gray-300 px-2 py-1 h-[26px] leading-[20px] cursor-pointer whitespace-nowrap overflow-hidden text-clip
    ${isCellSelected(index, "geometry") ? "bg-[#e6e6e6]" : ""}
    ${getSelectionBorderClass(index, "geometry")}
    ${isCopied && isCellSelected(index, "geometry") ? "copy-selection" : ""}
`}
>
  {row.geometryName ?? ""}
</td>

                {/* <td className="border border-gray-300 px-2 py-1 text-right">
                  {row.quantity ?? ""}
                </td> */}
              <td
  onMouseDown={() => {
     setSelectAll(false);
setIsCopied(false);
    setSelectionStart({
      row: index,
      column: "quantity",
    });

    setSelectionEnd({
      row: index,
      column: "quantity",
    });

    

    setIsSelecting(true);
  }}
  onMouseEnter={() => {
    if (!isSelecting) return;

    setSelectionEnd({
      row: index,
      column: "quantity",
    });
  }}
 /* className={`border border-gray-300 px-1 py-0 text-right cursor-pointer whitespace-nowrap overflow-hidden text-clip
    ${isCellSelected(index, "quantity") ? "bg-[#e6e6e6]" : ""}
     `} */

   // className={`border border-gray-300 px-1 py-0 text-right cursor-pointer whitespace-nowrap overflow-hidden text-clip
   className={`border border-gray-300 px-2 py-1 h-[26px] leading-[20px] text-right cursor-pointer whitespace-nowrap overflow-hidden text-clip
    ${isCellSelected(index, "quantity") ? "bg-[#e6e6e6]" : ""}
    ${getSelectionBorderClass(index, "quantity")}
    ${isCopied && isCellSelected(index, "quantity") ? "copy-selection" : ""}
`}
>
  {row.quantity != null
    ? row.quantity.toFixed(3)
    : ""}
</td>

<td
  onMouseDown={() => {
     setSelectAll(false);
setIsCopied(false);
    setSelectionStart({
      row: index,
      column: "submark",
    });

    setSelectionEnd({
      row: index,
      column: "submark",
    });

    

    setIsSelecting(true);
  }}
  onMouseEnter={() => {
    if (!isSelecting) return;

    setSelectionEnd({
      row: index,
      column: "submark",
    });
  }}
  //className={`border border-gray-300 px-2 py-1 cursor-pointer
 /* className={`border border-gray-300 px-1 py-0 cursor-pointer whitespace-nowrap overflow-hidden text-clip
    ${isCellSelected(index, "submark") ? "bg-[#e6e6e6]" : ""}
    `} */
  // className={`border border-gray-300 px-1 py-0 cursor-pointer whitespace-nowrap overflow-hidden text-clip
  className={`border border-gray-300 px-2 py-1 h-[26px] leading-[20px] cursor-pointer whitespace-nowrap overflow-hidden text-clip
    ${isCellSelected(index, "submark") ? "bg-[#e6e6e6]" : ""}
    ${getSelectionBorderClass(index, "submark")}
    ${isCopied && isCellSelected(index, "submark") ? "copy-selection" : ""}
`}
>
  {row.subMarkName ?? ""}
</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default TakeOffPanel;